import { Component } from '@angular/core';
import { OrderStateService } from 'src/app/core/service/order-state.service';
import { TSpecialPromoVendors } from 'src/app/core/types/type';

@Component({
  selector: 'app-common-layout',
  templateUrl: './common-layout.component.html',
  styleUrls: ['./common-layout.component.scss'],
})
export class CommonLayoutComponent {
  public get promoVendor(): TSpecialPromoVendors | null {
    return this.orderState.promoVendor;
  }

  // FORCE-8414 + FORCE-8556 + FORCE-8581 TO REVERT: Temporary promo banner for HCP Molly Maid + Jobber + Geico
  public get promoBannerTitle(): string | void {
    if (this.promoVendor === 'jobber') {
      const deviceName = this.orderState.planType === 'pro' ? 'Dashcam' : 'GPS Tracker';
      const deviceCost = this.orderState.planType === 'pro' ? 99 : 1;
      return `“$${deviceCost} ${deviceName} Fee + First Month Free” offer has been applied to your order.`;
    }
    if (this.promoVendor === 'hcp-molly-maid') {
      return 'FastTrack pricing for Molly Maid franchisees has been applied to your order.';
    }
    if (this.promoVendor === 'geico') {
      return 'GEICO-exclusive pricing has been applied to your order.';
    }
  }

  public get logoAssetPath(): string {
    const basePath = '/assets/icons/';

    if (this.promoVendor === 'jobber') {
      return basePath + 'force-jobber.svg';
    }
    if (this.promoVendor === 'hcp-molly-maid') {
      return basePath + 'force-housecallpro.svg';
    }
    if (this.promoVendor === 'geico') {
      return basePath + 'force-geico.svg';
    }
    return basePath + 'force.svg';
  }

  public get homeUrl(): string {
    const defaultUrl = 'https://forcefleettracking.com/';

    if (this.promoVendor === 'hcp-molly-maid') {
      return 'https://forcefleet.com/lp/housecall-pro-molly-maid-fast-track-program/';
    }
    if (this.promoVendor === 'geico') {
      return 'https://forcefleettracking.com/lp/geico-commercial-auto-insurance-perks/';
    }
    return defaultUrl;
  }

  constructor(public orderState: OrderStateService) {}
}
